import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from '@material-ui/core/styles';

import claimsIcon from '../../assets/img/icon-claims.png';
import householdIcon from '../../assets/img/icon-households.png';
import selfServiceIcon from '../../assets/img/icon-self-service.png';

const useStyles = makeStyles((theme) => {
  const {
    palette: { tenant },
    breakpoints,
  } = theme;

  return {
    container: {
      width: '100%',
      backgroundColor: tenant.white,
      padding: 24,
      [breakpoints.up('sm')]: {
        padding: 56,
      },
    },
    headerText: {
      [breakpoints.between('sm', 'md')]: {
        maxWidth: 632,
        margin: '0 auto',
      },
    },
    grid: {
      marginTop: 20,
    },
    gridBox: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      height: 268,
      paddingTop: 50,
      paddingBottom: 24,
      [breakpoints.up('sm')]: {
        padding: '50px 56px',
        width: 400,
        height: 268,
      },
      [breakpoints.up('md')]: {
        padding: '50px 24px',
      },
    },
    iconAdjust: {
      marginBottom: 15,
    },
  };
});

function ChooseFarmersSection() {
  const classes = useStyles();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <Container maxWidth={false} className={classes.container}>
      <Typography
        className={classes.headerText}
        align="center"
        variant="h2"
        color="primary"
        gutterBottom
      >
        Why should you choose auto insurance from Farmers?
      </Typography>
      <Container>
        <Grid
          container
          direction={isDesktop ? 'row' : 'column'}
          justify="space-around"
          alignItems={isDesktop ? 'baseline' : 'center'}
          className={classes.grid}
        >
          <Box className={classes.gridBox}>
            <img
              src={householdIcon}
              className={classes.iconAdjust}
              alt="10 million households"
            />
            <Typography align="center" variant="h4" color="primary">
              10 million households
            </Typography>
            <Typography align="center" variant="subtitle1">
              And for good reason: Farmers offers quality and value with every
              auto insurance policy.
            </Typography>
          </Box>

          <Box className={classes.gridBox}>
            <img
              src={selfServiceIcon}
              className={classes.iconAdjust}
              alt="24/7 self service"
            />
            <Typography align="center" variant="h4" color="primary">
              24/7 self-service
            </Typography>
            <Typography align="center" variant="subtitle1">
              It's easy to manage your account on your own schedule - and to get
              live agent support during business hours.
            </Typography>
          </Box>

          <Box className={classes.gridBox}>
            <img
              src={claimsIcon}
              className={classes.iconAdjust}
              alt="Best-in-class claims."
            />
            <Typography align="center" variant="h4" color="primary">
              Best-in-class claims service
            </Typography>
            <Typography align="center" variant="subtitle1">
              If you ever need to file a claim, you'll receive exceptional
              service from Farmers representatives.
            </Typography>
          </Box>
        </Grid>
      </Container>
    </Container>
  );
}

export default ChooseFarmersSection;
